import { Box, type BoxProps } from "@mantine/core";

interface MenuItemProps extends BoxProps {
  children: React.ReactNode;
}

function MenuItem({ children, ...boxProps }: MenuItemProps) {
  return (
    <Box component="li" flex="0 0 auto" pr={15} {...boxProps}>
      {children}
    </Box>
  );
}

export { MenuItem };
